import { type AdversarialContext, type AdversarialMode } from './use-adversarial-indicator';

import type { ConversationDetail } from '../../../lib/types';

/**
 * useAdversarial — PR-B.2 (Item 89) · Motor Neutro B4c-b.
 *
 * Camada de adaptação entre `ConversationDetail` e o `useAdversarialIndicator`.
 *
 * **O que a B4c-b consertou.** Este adapter lia `bond.sessionContext` sobre um `bond` que era
 * **stub literal `null`** no contrato — três camadas de morte de uma vez: o objeto nunca chegava,
 * o shape da lista não tinha `adversarialMode` (o campo que o badge exige) e `sessionContext`
 * nunca foi campo do `Bond` (a sessão é da `Conversation`). O caminho estava errado de origem, não
 * ficou obsoleto.
 *
 * Agora `bond` é real e a sessão restrita vem de `conversation.session`, **já resolvida pelo
 * servidor para quem pediu** — o FE nunca decide titularidade de caucus.
 *
 * **Comportamento canônico:**
 *   - `conversation.bond === null` (conversa sem vínculo — o caso comum NetComet) → `null`;
 *     o `<AdversarialBadge>` permanece oculto. Sem requisição extra.
 *   - com vínculo → devolve o contexto; o badge decide se renderiza (mode/capability).
 *
 * `adversarialMode === 'none'` é EXPOSTO ao caller de propósito (auditabilidade): quem oculta é o
 * `useAdversarialIndicator`, não este adapter.
 */
export function useAdversarial(conversation: ConversationDetail): AdversarialContext | null {
  const bond = conversation.bond;
  if (bond === null || bond === undefined) return null;
  return {
    // O wire tipa `adversarialMode` como `string` (é enum do Prisma, não do domínio do FE); o
    // conjunto de valores é o da ADR-040 e o indicator trata qualquer outro como não-adversarial.
    adversarialMode: bond.adversarialMode as AdversarialMode,
    caucus: conversation.session ?? null,
  };
}
